<template>
    <b-modal @hide="refreshPage" id="editAnnouncementMessageModal" size="lg"  class="popover-modal" hide-header hide-footer no-close-on-esc :scrollable='true' ref="editAnnouncementMessageModal">
      <div class="content-cont">
        <p class="header-title">Edit Announcement</p>
        <div class="bold-hint-modal">Editing unavailable after publishing.</div>
        <div class="hint-modal">You will not be able to edit this announcement because it has already been published.</div>
        <hr class="h-line" />
        <div class="action-btns">
            <button @click="refreshPage" class="dismiss-action-btn btn btn-primary" size="md">Okay</button>
        </div>
      </div>
    </b-modal>
</template>

<script>
  export default {
    name: "editAnnouncementMessageModal",
    methods: {
        refreshPage(){
            this.$router.push({ path: `/announcements` });
        }
    }
  }
</script>

<style lang="scss">
    div#editAnnouncementMessageModal {
        padding-inline-end:0px!important;
        border-radius: 26px;

        .modal-content .modal-body {
            padding: 40px 42px 24px 42px !important;
        }

        div#editAnnouncementMessageModal___BV_modal_content_ {
            width: 500px!important;
            top: 150px;
            border-radius: 26px;
        }
        .modal-content .modal-body {
            p.header-title {
                font-weight: 700;
                font-size: 17px;
                line-height: 20.4px;
                margin-bottom:40px;
                color: #000000;
                text-align: center;
            }
            .bold-hint-modal {
                width: 416px;
                color: #4A4A4A;
                text-align: center;
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 24px;
                font-family: Lato;
                line-height: 19.2px;
                text-underline-position: from-font;
                text-decoration-skip-ink: none;
            }
            .hint-modal{
                width: 416px;
                color: var(--939393, #4A4A4A);
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0.25px;
                font-family: Lato;
                line-height: 24px;
                text-underline-position: from-font;
                text-decoration-skip-ink: none;

            }
            .h-line{
                opacity: 0.15;
                background: #707070;
                margin-bottom: 24px;
                margin-top: 40px;
            }
            .action-btns{
                .dismiss-action-btn{
                    background:  #103F5E;;
                    border-radius: 16.6275px;
                    width:111px;
                    height:33px;
                    color:#FFFFFF;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 19px;
                    text-align: center;
                }
            }
        }
    }
    </style>